export const API_PATH_apiUserMngmtUserDelete = '/services/user-management/user';
